export interface CreditLimitData {
  defaultCreditLimit?: number
  defaultCreditLimitHighSeason?: number
  creditLimitSpringSeasonStart?: string
  creditLimitSpringSeasonEnd?: string
  creditLimitFallSeasonStart?: string
  creditLimitFallSeasonEnd?: string
}

export default class CreditLimit {
  public defaultCreditLimit: number | null = null;
  public defaultCreditLimitHighSeason: number | null = null;
  public creditLimitSpringSeasonStart: string = '';
  public creditLimitSpringSeasonEnd: string = '';
  public creditLimitFallSeasonStart: string = '';
  public creditLimitFallSeasonEnd: string = '';
  public springDateString: string = '';
  public fallDateString: string = '';
  public springDateRange: Array<string> = [];
  public fallDateRange: Array<string> = [];

  public constructor(data: CreditLimitData = {}) {
    this.springDateRange = [this.addFullDate(data.creditLimitSpringSeasonStart), this.addFullDate(data.creditLimitSpringSeasonEnd)]
    this.fallDateRange = [this.addFullDate(data.creditLimitFallSeasonStart), this.addFullDate(data.creditLimitFallSeasonEnd)]
    this.defaultCreditLimit = data.defaultCreditLimit ?? null;
    this.defaultCreditLimitHighSeason = data.defaultCreditLimitHighSeason ?? null;
    this.creditLimitSpringSeasonStart = this.formatDate(data.creditLimitSpringSeasonStart);
    this.creditLimitSpringSeasonEnd = this.formatDate(data.creditLimitSpringSeasonEnd);
    this.creditLimitFallSeasonStart = this.formatDate(data.creditLimitFallSeasonStart);
    this.creditLimitFallSeasonEnd = this.formatDate(data.creditLimitFallSeasonEnd);
    this.springDateString = this.formatDate(data.creditLimitSpringSeasonStart) + ' - ' + this.formatDate(data.creditLimitSpringSeasonEnd);
    this.fallDateString = this.formatDate(data.creditLimitFallSeasonStart) + ' - ' + this.formatDate(data.creditLimitFallSeasonEnd);
  }

  public formToModel(): Partial<CreditLimitData> {
    return {
      defaultCreditLimit: this.defaultCreditLimit,
      defaultCreditLimitHighSeason: this.defaultCreditLimitHighSeason,
      creditLimitSpringSeasonStart: this.formatDate(this.creditLimitSpringSeasonStart),
      creditLimitSpringSeasonEnd: this.formatDate(this.creditLimitSpringSeasonEnd),
      creditLimitFallSeasonStart: this.formatDate(this.creditLimitFallSeasonStart),
      creditLimitFallSeasonEnd: this.formatDate(this.creditLimitFallSeasonEnd),
    }
  }

  public formatDate(dateStr?: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${month}-${day}`;
  }

  private addFullDate(dateStr?: string): string {
    if (!dateStr) return '';
    const year = new Date().getFullYear();
    return `${year}-${dateStr}`;
  }
}
